<template>
   <div>
  	<div id="wprw-popUpContent" class="wprw_morning_blue" style="visibility: visible; transform: translateX(100vw);">
      <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"> 
            <div>
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
           <div style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;">
              <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
          </div> 
      </div>
        <div class="ui stackable grid wprw_width100" style="margin-top:70px;">
            <div id="wprw_popup_wheel_container_left" class="ten wide column middle aligned ">
                <div class="wprw-spinner wprw_wheel_popup_size">
                    <div class="wprw-ball"> <span></span></div>
                    <div class="wprw-platebg"></div>
                    <div id="wprw-toppart" class="wprw-topnodebox">
                        <div class="wprw-platetop"></div>
                        <div class="wprw-topparttop2">
                            <div class="wprw-silvernode"></div>
                            <div class="wprw-topnode wprw-silverbg"></div> <span
                                class="wprw-top wprw-silverbg"></span> <span
                                class="wprw-right wprw-silverbg"></span> <span
                                class="wprw-down wprw-silverbg"></span> <span
                                class="wprw-left wprw-silverbg"></span>
                        </div>
                    </div>
                    <div id="wprw-rcircle" class="wprw-pieContainer">
                        <div class="wprw-pieBackground"></div>
                    </div>
                </div>
            </div>
            <div id="wprw_popup_wheel_container_right" class="six wide column middle aligned">
                <form id="wprw_main_popup_form" class="ui large form" method="post" action=""> <input type="hidden"
                        name="wprw_checksubmitted" value="1">
                        <button id="wprw-btnSpin" class="ui button" type="submit" v-show="check"> หมุนได้เลย
                    </button>
                </form>
            </div>
        </div>
        <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
         <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
              <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                  <span class="glow">
                    {{loadingtext}}
                  </span>
              </div>
          </div> 
       </div>
    </div>
    </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import liffService from "@/services/liff";
import "../assets/css/semantic.min.css";
import "../assets/css/wproulettewheel.css";
import "../assets/css/wheel.css";
// @ is an alias to /src
const audio = new Audio(require('../assets/RouletteWheel1.mp3'));
export default {
  name: "Roulet3",
  mounted() {
    this.showLoading = false;
		// LIFF is already initialized by router guard
		this.loadUserData();
		setTimeout(() => {
			this.numbersLocation = this.createWheel();
			window.jQuery("#wprw_input_form").submit((e) => {
				// Prevent actually submitting the form
				e.preventDefault();
				this.startWheelSequence('website');
			});

			window.jQuery("#wprw_main_popup_form").submit((e)=>{
				//Prevent actually submitting the form
				e.preventDefault();
				this.startWheelSequence('popup');
				audio.volume=0;
				audio.play();
				audio.pause();
			});
		}, 200);
  },
  data() {
    return {
	  showLoading:true,
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
      displayName: "",
      //email: "",
	  user:[],
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      quizId:0,
      answer:0,
      running:false,
      angle:0,
      wheels:null,
      frame:null,
      canvas:null,
      numbersLocation:[],
      rand:0,
	  numorder:[0,300,33,44,35,40,45,50,55,60,100,65,70,75,80,85,90,95,100,88,200,60,55,50,45,40,35,44,33],
	  check:false,
    };
  },
  methods: {
    spinTo(num) {
      //get location
	  const temp = this.numbersLocation[num][0] + 4;
	  //randomize
	  const randomSpace = Math.floor(Math.random() * 360 + 1);

	  this.resetAnimation();
	  setTimeout(()=> {
		this.bgRotateTo(randomSpace);
		this.ballRotateTo(randomSpace + temp);
		setTimeout(this.playSound(),500);
	  }, 500);
    },
    playSound() {
		audio.volume=0.6;
		audio.play();
	},
    ballRotateTo(deg) {
		const ballSpinTime = 4;
		const rotationsTime = 8;
		const destination = -360 * ballSpinTime - (360 - deg);
		window.jQuery.keyframe.define({
			name: "rotate2",
			from: {
				'transform': "rotate(0deg) translateY(0em)"
			},
			to: {
				'transform': "rotate(" + destination + "deg) translateY(5em)"
			}
		});

		window.jQuery.keyframe.define({
			name: "rotateBallStart",
			from: {
				transform: "rotate(0deg) translate(0px, 0px)"
			},
			to: {
				transform: "rotate(-2880deg) translate(0px, 0px)"
			}
		});

		window.jQuery.keyframe.define({
			name: "rotateBallEnd",
			from: {
				transform: "rotate(" + destination + "deg) translateY(5em)"
			},
			to: {
				transform: "rotate(" + (destination + 700) + "deg) translateY(5em)"
			}
		});
		const ballbg = window.jQuery(".wprw-ball");
		
		window.jQuery(ballbg).playKeyframe({
				name: "rotateBallStart", 
				duration: '4s', 
				timingFunction: "cubic-bezier(0.15,0,1,1)", 
			});
		setTimeout(function(){
			window.jQuery(ballbg).playKeyframe({
				name: "rotate2", 
				duration: (rotationsTime - 4) + 's', 
				timingFunction: "ease-out", 
			});
		}, 4000);
		setTimeout(function(){
			window.jQuery(ballbg).playKeyframe({
				name: "rotateBallEnd", 
				duration: '7s', 
				timingFunction: "ease-out",
			});
		}, 8000);
    },
    bgRotateTo(deg) {
		const numbg = window.jQuery(".wprw-pieContainer");
		const toppart = window.jQuery("#wprw-toppart");
		const wheelSpinTime = 2;
		const rotationsTime = 8;
		const destination = 360 * wheelSpinTime + deg;
		const temptime = (rotationsTime * 1000) / 1000 + 's';

		window.jQuery.keyframe.define({
			name: "rotate",
			from: {
				transform: "rotate(0deg)"
			},
			to: {
				transform: "rotate(" + destination + "deg)"
			}
		});

		window.jQuery.keyframe.define({
			name: "rotateEnd",
			from: {
				transform: "rotate(" + destination + "deg)"
			},
			to: {
				transform: "rotate(" + (destination + 700) + "deg)"
			}
		});
		window.jQuery(numbg).playKeyframe({
			name: "rotate", 
			duration: temptime, 
			timingFunction: "ease-in",
		});

		window.jQuery(toppart).playKeyframe({
			name: "rotate", 
			duration: temptime, 
			timingFunction: "ease-in",
		});

		
		setTimeout(function(){
			window.jQuery(numbg).playKeyframe({
				name: "rotateEnd", 
				duration: '7s', 
				timingFunction: "ease-out",
			});
			window.jQuery(toppart).playKeyframe({
				name: "rotateEnd", 
				duration: '7s', 
				timingFunction: "ease-out",
			});
		}, 8000);
		
	},
    resetAnimation() {
		const animationPlayState = "animation-play-state";
		const playStateRunning = "running";

		const pfx = window.jQuery.keyframe.getVendorPrefix();
		 window.jQuery(".wprw-ball").css(pfx + animationPlayState, playStateRunning).css(pfx + "animation", "none");
		 window.jQuery(".wprw-pieContainer").css(pfx + animationPlayState, playStateRunning).css(pfx + "animation", "none");
		 window.jQuery("#wprw-toppart").css(pfx + animationPlayState, playStateRunning).css(pfx + "animation", "none");

		 window.jQuery("#rotate2").html("");
		 window.jQuery("#rotate").html("");
	},
    startWheelSequence(integration){
		window.jQuery('#wprw-btnSpin').attr('disabled','true');
		let dataform = '';
		if (integration === 'popup'){
			dataform += window.jQuery("#wprw_main_popup_form").serialize();
		} else if (integration === 'website') {
			dataform += window.jQuery("#wprw_input_form").serialize();
		}
		dataform += '&action=handlepermissionrequest';
		dataform += '&security=7a7bbe6a7c';  // Add nonce security to request
        this.beginWheelSpin(integration); 
    },
    winFunction(integration) {
		this.displayWinMessage('yes', integration);
    },
    displayWinMessage(coupon, integration){
        setTimeout(()=>{
			if(this.numorder[this.rand] == 0){
				this.$confirm(
					{
						message: `🏟 TT พรุ่งนี้มาหมุนด้วยกันใหม่นะคะ 😘😘`,
						button: {
						yes: 'OK'
						},
						callback: async (confirm) => {
							if (confirm) {
								this.sendMessageLine("TT พรุ่งนี้มาหมุนด้วยกันใหม่นะคะ 😘😘");
							}
						}
					}
            	);	
			}else{
				this.$confirm(
					{
						message: `🏟 ปังปุรีเย่!! คุณได้รับ ${this.numorder[this.rand]} เครดิต😘😘`,
						button: {
						yes: 'OK'
						},
						callback: async (confirm) => {
							if (confirm) {
								this.sendMessageLine3(this.numorder[this.rand]);
							}
						}
					}
            	);	
			}
		}, 15500);
    },
    randomFixed(){
        let rand = Math.random()*this.numorder.length|0;
        if (rand == 20 || rand == 1) {
        //if (rand == 16 || rand ==-1 || rand == 14 || rand == 16) {
            rand = this.randomFixed();
        }
        return rand;
    },
    beginWheelSpin(integration){
        this.rand = this.randomFixed();
		setTimeout(() => {
            // Check against Win Probability
			this.spinTo(this.numorder[this.rand]);
			this.winFunction(integration);
		}, 500);
        setTimeout(() => {
            if(this.userId){
                firebase.firestore().collection('roulet').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
                    userId:this.userId,
                    createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                    value:Number(this.numorder[this.rand])
                });
            }
        },4000);

		// Remove Form if integration is Pop-up
		if (integration === 'popup'){
			window.jQuery("#wprw_main_popup_form, #wprw_popup_header_container ").css('opacity', 0);
			setTimeout(() => {
				window.jQuery("#wprw_main_popup_form, #wprw_popup_header_container").css('display','none');
				//Bring wheel to center, if wheel is sideways (width > 768 );
				if ( window.jQuery(window).width() > 768 ) {
					window.jQuery("#wprw_popup_wheel_container_right").css('display','none');
					window.jQuery(".wprw-spinner").css('transform', 'translateX(30%)');
					setTimeout(() => {
						// Move Back the wheel when the animation ends
						this.moveWheelBack();
					}, 10000);
				}
			}, 500);
		}
	},
    createWheel() {
		const numred = [300,44,40,50,60,65,75,85,95,88];
		const numblack = [33,35,45,55,100,65,70,80,90,200];
		const numgreen = [0];

		const temparc = 360 / this.numorder.length;
		for (let i = 0; i < this.numorder.length; i++) {
			this.numbersLocation[this.numorder[i]] = [];
			this.numbersLocation[this.numorder[i]][0] = i * temparc;
			this.numbersLocation[this.numorder[i]][1] = i * temparc + temparc;

			const newSlice = document.createElement("div");
			window.jQuery(newSlice).addClass("wprw-hold");
			const newHold = document.createElement("div");
			window.jQuery(newHold).addClass("wprw-pie");
			const newNumber = document.createElement("div");
			window.jQuery(newNumber).addClass("wprw-num");

			newNumber.innerHTML = this.numorder[i];
			window.jQuery(newSlice).attr("id", "rSlice" + i);
			window.jQuery(newSlice).css("transform","rotate(" + this.numbersLocation[this.numorder[i]][0] + "deg)");

			window.jQuery(newHold).css("transform", "rotate(12.73deg)");
			window.jQuery(newHold).css("-webkit-transform", "rotate(12.73deg)");

			if (window.jQuery.inArray(this.numorder[i], numgreen) > -1) {
				window.jQuery(newHold).addClass("wprw-greenbg");
			} else if (window.jQuery.inArray(this.numorder[i], numred) > -1) {
				window.jQuery(newHold).addClass("wprw-redbg");
			} else if (window.jQuery.inArray(this.numorder[i], numblack) > -1) {
				window.jQuery(newHold).addClass("wprw-greybg");
			} 

			window.jQuery(newNumber).appendTo(newSlice);
			window.jQuery(newHold).appendTo(newSlice);

			const rinner = window.jQuery("#wprw-rcircle");
			window.jQuery(newSlice).appendTo(rinner);
		}
		return this.numbersLocation;
	},
	async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🏟  "+text,
          },
      ]);
	},
	async sendMessageLine3(text){
      await window.liff.sendMessages([{
        "type": "flex",
        "altText": 'ปังปุรีเย่!! คุณได้รับ '+text+' เครดิต',
        "contents": {
			"type": "bubble",
			"size": "micro",
			"body": {
				"type": "box",
				"layout": "vertical",
				"contents": [
				{
					"type": "text",
					"text": "ยินดีด้วยค่ะ !",
					"color": "#f48c0c",
					"size": "lg",
					"weight": "bold",
					"align": "center"
				},
				{
					"type": "image",
					"url": "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fchips.png?alt=media",
					"position": "relative",
					"size": "sm"
				},
				{
					"type": "text",
					"text": "+"+text+" เครดิต",
					"size": "sm",
					"color": "#f48c0c",
					"align": "center",
					"weight": "bold"
				}
				],
				"spacing": "xxl",
				"margin": "none",
				"action": {
				"type": "uri",
				"label": "action",
				"uri": "https://liff.line.me/2006378234-72e9GVNa/reward",
				"altUri": {
					"desktop": "https://liff.line.me/2006378234-72e9GVNa/reward"
				}
				},
				"background": {
				"type": "linearGradient",
				"angle": "0deg",
				"startColor": "#1F1C18",
				"endColor": "#8E0E00"
				}
			},
			"styles": {
				"footer": {
				"separator": true
				}
			}
			}
          }]);
      window.liff.closeWindow();
    },
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🏟  "+text,
          },
      ]);
      window.liff.closeWindow();
    },
    async loadUserData() {
		if (!window.liff.isInClient()) {
          	router.replace("/login");
      	}else{
			// Get profile from centralized service (already fetched by router guard)
			const profile = liffService.profile;
			if (!profile) return;

			this.userId = profile.userId || "none";
			this.displayName = profile.displayName || "none";
			this.pictureUrl = profile.pictureUrl || "none";
			this.statusMessage = profile.statusMessage || "none";
			if (this.userId) {
				const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
				if (user) {
					const u = user[Object.keys(user)[0]];
					this.user = u;
					this.mycoin = (u.coins)?u.coins:0;
					this.userKey = Object.keys(user)[0];
					this.sendMessageLine2("สนใจเล่นรูเล็ต พลอยใสจัดการให้หน่อย 😘😘");
					await firebase.firestore().collection('rouletcheck').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
						if(snapshot.exists) {
							this.sendMessageLine("ลูกค้าหมุนรูเล็ตของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘😘");
						}
					});
					await firebase.firestore().collection('roulet').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
						if(snapshot.exists) {
							this.sendMessageLine("ลูกค้าหมุนรูเล็ตของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘😘");
						}else{
						await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
							let credit = 0;
							snapshot.forEach((doc)=>{
							credit += Number(doc.data().qty);
							});
							if(credit >= 1000){
							this.loadingtext = 'น้องออโต้พร้อมแล้ว หมุนได้เลยค่ะ😘😘';
							this.check = true;
							}else{
							const less = 1000-Number(credit);
							this.loadingtext = `เติมเงินอีก ${less}(1000) ได้เล่นเลยค่ะ!😘😘`;
							//this.loadingtext = `สนใจเล่นรูเล็ต สอบถามแอดมินได้เลยนะคะ!😘😘`;
							}
						});
						}
					});
				}else{
					router.replace("/register");
				}
			}
			this.isDisabled = false;
		}
    }
  }
};
</script>
<style scoped>
.glow {
            color: #fff;
            text-align: center;
            -webkit-animation: glow 1s ease-in-out infinite alternate;
            -moz-animation: glow 1s ease-in-out infinite alternate;
            animation: glow 1s ease-in-out infinite alternate;
            }

            @-webkit-keyframes glow {
            from {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
            
            to {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
        }
</style>